module.exports = __webpack_public_path__ + "static/media/it.6c0c12a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/languages/it.svg
// module id = 1867
// module chunks = 0